module.exports = __webpack_public_path__ + "img/go_shop.11e32eb8.png";